import { render } from "./Barcode_Scan.vue?vue&type=template&id=21c13d8f"
import script from "./Barcode_Scan.vue?vue&type=script&lang=js"
export * from "./Barcode_Scan.vue?vue&type=script&lang=js"

import "./Barcode_Scan.vue?vue&type=style&index=0&id=21c13d8f&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__